import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';

interface EditProductUnitPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  onUpdate: (unitData: {
    id: number;
    name: string;
    unitCode: string;
    mhCode: number;
  }) => void;
  selectedUnit: {
    id: number;
    name: string;
    unitCode: string;
    mhCode: number;
  } | null;
}

const EditProductUnitPopup: React.FC<EditProductUnitPopupProps> = ({
  popupOpen,
  setPopupOpen,
  onUpdate,
  selectedUnit,
}) => {

  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'Debe tener al menos 2 caracteres')
      .required('El nombre es obligatorio'),

    unitCode: Yup.string()
      .min(1, 'Debe tener al menos 1 carácter')
      .max(10, 'Máximo 10 caracteres')
      .required('El código de unidad es obligatorio'),

    mhCode: Yup.number()
      .typeError('Debe ser un número')
      .required('El código MH es obligatorio')
      .min(1, 'Debe ser mayor a 0'),
  });

  const formik = useFormik({
    initialValues: {
      id: selectedUnit?.id || 0,
      name: selectedUnit?.name || '',
      unitCode: selectedUnit?.unitCode || '',
      mhCode: selectedUnit?.mhCode || '',
    },
    validationSchema,
    onSubmit: (values) => {
      onUpdate({
        id: values.id,
        name: values.name,
        unitCode: values.unitCode,
        mhCode: Number(values.mhCode),
      });
      setPopupOpen(false);
    },
    enableReinitialize: true,
  });

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Editar Unidad de Medida"
      maxWidth="max-w-md"
    >
      <form onSubmit={formik.handleSubmit} className="mt-4">

        <InputField
          label="Nombre"
          name="name"
          type="text"
          iconKey="edit"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && formik.errors.name ? formik.errors.name : undefined}
        />

        <InputField
          label="Código de Unidad"
          name="unitCode"
          type="text"
          iconKey="edit"
          placeholder="Ej: KG, LT, MT"
          value={formik.values.unitCode}
          onChange={formik.handleChange}
          error={formik.touched.unitCode && formik.errors.unitCode ? formik.errors.unitCode : undefined}
        />

        <InputField
          label="Código MH"
          name="mhCode"
          type="number"
          iconKey="hash"
          placeholder="Ej: 59, 03, 41"
          value={formik.values.mhCode}
          onChange={formik.handleChange}
          min={0}
          error={formik.touched.mhCode && formik.errors.mhCode ? formik.errors.mhCode : undefined}
        />

        <button
          type="submit"
          className="w-full rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90 mt-4"
        >
          Guardar Cambios
        </button>
      </form>
    </FormModal>
  );
};

export default EditProductUnitPopup;
